<script setup lang="ts">
import {ConsumerProduct} from "@/consumer/interfaces";
import {onMounted, ref} from "vue";
import {drugInteractionApi} from "@/container";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";

const props = defineProps<{
    customerId: number;
    products: ConsumerProduct[];
}>();

defineEmits<{
    (e: 'next'): void
}>();

const loading = ref(false);
const error = ref<string | undefined>();
const priscaPath = ref<string | undefined>();

const getPriscaPath = async (codes: string[]) => {
    try {
        error.value = undefined;
        loading.value = true;
        const response = await drugInteractionApi().read(codes, props.customerId);

        priscaPath.value = response.prisca_path;
    } catch {
        error.value = "Une erreur est survenue lors de la récupération des données d'interaction.";
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    getPriscaPath(
        props.products.map(product => product.product.cip)
    );
});
</script>

<template>
  <BaseFlexSpinner v-if="loading" />
  <div v-else-if="error">
    <p>{{ error }}</p>
  </div>
  <div v-else class="flex-1 flex flex-col gap-4">
    <iframe
      class="flex-1 w-full"
      loading="lazy"
      :src="priscaPath"
    />
    <BaseButton class="self-end" primary @click="$emit('next')">
      Suivant
    </BaseButton>
  </div>
</template>

<style scoped>

</style>
